import Vue from 'vue';
export const EventBus = new Vue();

export const EventBusCommands = {
    R_TOKEN_EXPIRED : "REFRESH_TOKEN_EXPIRE"
}